import { gql, TypedDocumentNode } from "@apollo/client";

import {
  UpdateUserTeamMutation,
  UpdateUserTeamMutationVariables,
} from "./UpdateUserTeam.generated";

const UPDATE_USER_TEAM: TypedDocumentNode<
  UpdateUserTeamMutation,
  UpdateUserTeamMutationVariables
> = gql`
  mutation updateUserTeam(
    $teamUuid: String!
    $userUuid: String!
    $roleId: Int
    $isAdmin: Boolean
    $accountType: String
  ) {
    updateUserTeam(
      teamUuid: $teamUuid
      userUuid: $userUuid
      roleId: $roleId
      isAdmin: $isAdmin
      accountType: $accountType
    ) {
      ok
      billingImplication
    }
  }
`;

export default UPDATE_USER_TEAM;
